import { Mic, Square } from "lucide-react";

const LABELS = {
  es: { listening: "Parar", idle: "Hablar" },
  ar: { listening: "وقف", idle: "هضر" },
};

function buttonTone(listening, lang) {
  if (listening) return "mic-pulse bg-emerald-500 text-white shadow-emerald-500/40";
  if (lang === "ar") return "bg-amber-500 text-slate-950 shadow-amber-500/30 hover:bg-amber-400";
  return "bg-blue-600 text-white shadow-blue-600/30 hover:bg-blue-500";
}

export const MicButton = ({ listening, onClick, lang, testId, disabled }) => {
  const isAr = lang === "ar";
  const label = LABELS[lang][listening ? "listening" : "idle"];
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={listening}
      className={`relative flex h-16 min-w-[160px] items-center justify-center gap-3 rounded-full px-7 text-lg font-bold shadow-lg transition-[transform,background-color,box-shadow] duration-200 active:scale-95 disabled:opacity-50 ${buttonTone(listening, lang)}`}
    >
      <span className="relative z-10 flex items-center gap-3">
        {listening ? <Square className="h-5 w-5 fill-current" /> : <Mic className="h-6 w-6" />}
        <span className={isAr ? "font-arabic text-xl" : ""}>{label}</span>
      </span>
    </button>
  );
};
